import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const DashboardValidationOfProposalsWidgets = ({
  data,
  loading,
  isShow,
}) => {
  const DashboardValidationOfProposalsWidgetsSkeleton = () => {
    return (
      <Row className="mb-3">
        <Col xs={12} md={4} lg={4}>
          <SkeletonTheme baseColor="#8B919F">
            <Skeleton height={120} />
          </SkeletonTheme>
        </Col>
      </Row>
    );
  };

  return loading ? (
    <DashboardValidationOfProposalsWidgetsSkeleton />
  ) : isShow ? (
    <Row>
      <Col xs={12} md={4} lg={4}>
        <Card className="card-animate overflow-hidden">
          <div className="position-absolute start-0" style={{ zIndex: '0' }}>
            <svg
              version="1.2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 200 120"
              width="200"
              height="140"
            >
              <path
                id="Shape 8"
                style={{ opacity: '.05', fill: 'rgb(128 128 128)' }}
                d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z"
              />
            </svg>
          </div>
          <CardBody style={{ zIndex: '1' }}>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 overflow-hidden">
                <h1>
                  <i className="ri-time-line"></i>
                </h1>
              </div>
              <div className="flex-shrink-0 mb-2">
                <h4 className="fs-22 fw-semibold ff-secondary mb-3 text-end">
                  <span className="counter-value">
                    {data?.resume?.preProposalsWaitingApproval || '0'}
                  </span>
                </h4>
                <span className="fw-medium text-muted text-truncate">
                  Aguardando Aprovação
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-end border-top border-top-dashed">
              <Link
                to={{
                  pathname: '/pre-proposta',
                  state: data?.resume?.preProposalsWaitingApproval,
                }}
                className="link-primary pt-2 pe-1"
              >
                Ver mais <i className="ri-arrow-right-line align-middle"></i>
              </Link>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  ) : null;
};
